export default __webpack_public_path__ + "static/media/lateral-right-demo.cddcd832.png";